import { DEFAULT_GUARANTEE, guaranteeBySubtype } from '../game-utils';
import { gameImagePublicId } from '../cloudinary';

export const parseOrderDetails = (order) => {
  const guarantees = [];

  // shallow clone game object, apollo data is read-only
  const games = order?.orderItems
    ?.filter?.((item) => item.type == 'GameOrderItem')
    .map((orderItem) => {
      const { game } = orderItem;
      if (!game) {
        return orderItem;
      }

      guarantees.push(
        game?.moneyBackGuaranteeDays || guaranteeBySubtype(game.subtype)
      );

      if (game.image?.publicId) {
        return orderItem;
      }

      return {
        ...orderItem,
        game: {
          ...game,
          image: {
            publicId: gameImagePublicId(
              game.squareImageUrl || game.imageUrl,
              game.type
            ),
          },
        },
      };
    });

  const bets = order?.orderItems?.filter?.(
    (item) => item.type == 'GameBetOrderItem'
  );
  const discounts =
    order?.orderItems
      ?.filter?.(
        (item) =>
          ['PromoOrderItem'].includes(item.type) ||
          (['ChipsOrderItem', 'PointsOrderItem'].includes(item.type) &&
            item.amount !== 0)
      )
      ?.sort?.(({ type }, { type: nextType }) => {
        if (type < nextType) return -1;
        if (type === nextType) return 0;
        if (type > nextType) return 1;
      }) || [];
  const memberships =
    order?.orderItems?.filter?.((item) => item.type == 'MembershipOrderItem') ||
    [];
  const hasPromoCodes = !!discounts.some((d) => d.type == 'PromoOrderItem');
  const guaranteeDays =
    guarantees.length === 0 ? DEFAULT_GUARANTEE : Math.min(...guarantees);
  const isAdHocMembershipOrder = order?.type === 'AdHocMembershipOrder';
  const hasFreeTrial = memberships.some((item) => item.isFreeTrial);

  return {
    bets,
    discounts,
    games,
    guaranteeDays,
    hasFreeTrial,
    hasPromoCodes,
    isAdHocMembershipOrder,
    memberships,
  };
};
